import React from 'react';
import { useSelector } from 'react-redux';
import { INTERACTION_MODE } from 'pxc-editor-material-svg-rendering/constants';
import { Home } from '@/pages';
import WizardMode from '@/components/pages/WizardMode';

const Container = () => {
  const { mode } = useSelector(state => state.core.mode);
  
  switch (mode) {
    case INTERACTION_MODE.WIZARD: {
      return <WizardMode />;
    }
    default: {
      return <Home />;
    }
  }
};

export default Container;
